import { AttachMoney, Cancel, CheckCircle, Error, HourglassEmpty, Schedule, Payment } from "@mui/icons-material";
import { alpha, Chip, SvgIconProps } from "@mui/material";
import { blue, green, grey, orange, red, yellow } from "@mui/material/colors";
import { chipOpacity, chipPadding } from "./common";
import { MerchantOrdersInvoiceState } from "../../../interfaces/common/merchant-invoices";
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import ReplayIcon from '@mui/icons-material/Replay';

export const getInvoiceStateColor = (state: MerchantOrdersInvoiceState): string => {
    switch (state) {
        case MerchantOrdersInvoiceState.PENDING_PAYMENT:
            return alpha(yellow[700], chipOpacity);
        case MerchantOrdersInvoiceState.PAYMENT_SCHEDULED:
            return alpha(blue[500], chipOpacity);
        case MerchantOrdersInvoiceState.COLLECTED_BY_DRIVER:
            return alpha(orange[300], chipOpacity);
        case MerchantOrdersInvoiceState.IN_PROGRESS:
            return alpha(orange[500], chipOpacity);
        case MerchantOrdersInvoiceState.PAID:
            return alpha(green[500], chipOpacity);
        case MerchantOrdersInvoiceState.FAILED:
            return alpha(red[500], chipOpacity);
        case MerchantOrdersInvoiceState.AWAITING_RETURN:
            return alpha(orange[700], chipOpacity);
        case MerchantOrdersInvoiceState.CANCELLED:
            return alpha(grey[700], chipOpacity);
        default:
            return alpha(grey[500], chipOpacity);
    }
};

export const getInvoiceStateIcon = (state: MerchantOrdersInvoiceState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: "small", color: "inherit" };

    switch (state) {
        case MerchantOrdersInvoiceState.PENDING_PAYMENT:
            return <HourglassEmpty {...iconProps} />;
        case MerchantOrdersInvoiceState.PAYMENT_SCHEDULED:
            return <Schedule {...iconProps} />;
        case MerchantOrdersInvoiceState.COLLECTED_BY_DRIVER:
            return <DirectionsWalkIcon {...iconProps} />;
        case MerchantOrdersInvoiceState.IN_PROGRESS:
            return <Payment {...iconProps} />;
        case MerchantOrdersInvoiceState.PAID:
            return <CheckCircle {...iconProps} />;
        case MerchantOrdersInvoiceState.AWAITING_RETURN:
            return <ReplayIcon {...iconProps} />;
        case MerchantOrdersInvoiceState.FAILED:
            return <Error {...iconProps} />;
        case MerchantOrdersInvoiceState.CANCELLED:
            return <Cancel {...iconProps} />;
    }
};

export const showInvoiceState = (state: MerchantOrdersInvoiceState): JSX.Element => {
    return (
        <Chip
            icon={getInvoiceStateIcon(state)}
            label={<b>{state.toString().replaceAll("_", " ")}</b>}
            variant="filled"
            style={{
                margin: 4,
                padding: chipPadding,
                backgroundColor: getInvoiceStateColor(state),
            }}
        />
    );
};
